/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { useCallback } from 'react';

import { Typography2, breakpoints } from '@coursera/cds-core';

import { useDegreeDescriptionPageElementRefs } from 'bundles/degree-description/contexts/DegreeDescriptionPageElementRefsContext';
import { useDegreeDescriptionEventingContext } from 'bundles/degree-description/providers/DegreeDescriptionEventingProvider';

type Props = {
  trackingIndex?: number;
};

// TODO: redesign-2026 -- placeholder box; the real EOI form lands in a follow-up PR.
const styles = {
  container: css`
    background: var(--cds-color-neutral-background-primary);
    border-radius: 8px;
    padding: var(--cds-spacing-200) var(--cds-spacing-300);

    ${breakpoints.up('lg')} {
      padding: var(--cds-spacing-300) var(--cds-spacing-400);
    }
  `,
  title: css`
    margin-bottom: 0;
  `,
};

const ExperimentalEoiForm = ({ trackingIndex }: Props) => {
  const { useGetViewPageSectionRef } = useDegreeDescriptionEventingContext();
  const { setEoiFormAnchorRef } = useDegreeDescriptionPageElementRefs();
  const pageSectionRef = useGetViewPageSectionRef('eoi', trackingIndex);

  // pageSectionRef and setEoiFormAnchorRef are both stable across renders (a MutableRefObject and
  // a useState setter, respectively), so this merged ref callback keeps a stable identity too.
  const setFormRef = useCallback<(e: HTMLDivElement | null) => void>(
    (e) => {
      pageSectionRef.current = e;
      setEoiFormAnchorRef?.(e as HTMLElement);
    },
    [pageSectionRef, setEoiFormAnchorRef]
  );

  return (
    <div css={styles.container} ref={setFormRef} data-testid="experimental-eoi-form">
      <Typography2 component="h3" variant="titleSmall" css={styles.title}>
        Placeholder for the EOI form -- will be replaced with the real form in a follow-up PR.
      </Typography2>
    </div>
  );
};

export default ExperimentalEoiForm;
